import { defaultDataIdFromObject } from "apollo-cache-inmemory";
import { get } from "@insightfulscience/shared-utils/fn";

const get1 = get(1);

export const subscriptionId = ({ subscriptionID }) => `Subscription:${subscriptionID}`;

subscriptionId.parse = id => get1(/^Subscription:(.*)$/.exec(id));

export const orderId = ({ orderNumber }) => `Order:${orderNumber}`;

orderId.parse = id => get1(/^Order:(.*)$/.exec(id));

export const serialNumberId = ({ serialNumber }) => `SerialNumber:${serialNumber}`;

serialNumberId.parse = id => get1(/^SerialNumber:(.*)$/.exec(id));

export const perpetualId = ({ id }) => `Perpetual:${id}`;

perpetualId.parse = id => get1(/^Perpetual:(.*)$/.exec(id));

export const orderNumberId = ({ serialNumber }) => serialNumber;

export const currentCartId = () => "CURRENT:CART";

const dataIdMap = new Map([
	["Subscription", subscriptionId],
	["Order", orderId],
	["SerialNumber", orderNumberId],
	["CartResponse", currentCartId],
]);

const dataIdFromObject = object => {
	// eslint-disable-next-line no-underscore-dangle
	const getId = dataIdMap.get(object.__typename) || defaultDataIdFromObject;
	return getId(object);
};

export default dataIdFromObject;
